<template>
  <div class="fundo_cor_faculdade2" v-if="$store.state.faculdade != null">
    <BreadCrumb
          class="orgaos_breadcrumb"
          :showBread="true"
          :breadcrumb="breadcrumb"/>
    <div class="row align-center orgaoslist">
      <div class="small-11 medium-11 large-10 columns">
        <div class="fundo_papel5">
          <div class="botao_fac">
            <a class="button botao_faculdade darkbackground"
               :class="$store.state.faculdadename">
              {{ $store.state.faculdade?.nome }}
            </a>
          </div>
          <OrgaoSlide
            :key="orgao.nome"
            v-for="orgao in orgaosWithCargos"
            :lang="this.language"
            :nome="orgao.Nome"
            :cargos="orgao.Cargos"
            :faculdadename="$store.state.faculdadename"/>
          <div class="wrap" v-if="departamentos?.length > 0">
            <TitleWithLine
                :nome="$translate('UMA_LANG_FO_DEPARTAMENTOS')"
                :faculdadename="$store.state.faculdadename"/>
            <div class="row departamentos4">
              <Departamento
                :key="departamento.Nome"
                @click="goToDepartamento(departamento)"
                class="departamentoblock"
                :faculdadename="$store.state.faculdadename"
                :nome="departamento.Nome"
                v-for="departamento in departamentos"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../axios.js";
import Pessoa from "../components/Pessoa.vue";
import Departamento from '../components/Departamento.vue';
import { BreadCrumb } from "umaui";
import OrgaoSlide from "../components/OrgaoSlide.vue";
import TitleWithLine from "../components/TitleWithLine.vue";

export default {
  name: "OrgaosDepartamentos",
  inject:["id","language","i18n"],
  components:{
    Pessoa,
    Departamento,
    BreadCrumb,
    OrgaoSlide,
    TitleWithLine
  },
  data(){
    return {
      orgaos: [],
      departamentos:[]
    }
  },
  computed:{
    breadcrumb(){
      let baseurl = import.meta.env.VITE_APP_SITE_URL;
      if(this.language == "en"){
        baseurl = baseurl+"/en";
      }
      return [
        { ID: 1, text: "Homepage",
          href:import.meta.env.VITE_APP_SITE_URL},
        { ID: 2, text: this.$translate("UMA_LANG_FACULDADE_BREADCRUMB_SOBRE"),
          href:baseurl+"/sobre"},
        { ID: 3, text: this.$translate("UMA_LANG_FACULDADE_BREADCRUMB_FE"),
          href:baseurl+"/sobre/faculdades-e-escolas/"},
        { ID: 4, text: this.$store.state.faculdade?.sigla,
          route: { to: "/" } },
        { ID: 5, text: this.$translate("UMA_LANG_FACULDADE_ORGAOSEDEPARTAMENTOS"),
          route: { to: "/orgaos-e-departamentos" } }
      ]
    },
    orgaosWithCargos(){
      console.log(this.orgaos);
      const filteredOrgaos = this.orgaos.filter(el => el.Cargos.length > 0);
      console.log(filteredOrgaos);
      return filteredOrgaos;
    }
  },
  created() {
    axios.get(`/faculdades/${this.id}/orgaos?idioma=${this.language}`)
        .then(data => {
          this.orgaos = data.data;
          console.log(this.orgaos);
          this.orgaos.sort((a,b) => {
            if(a?.Ordem < b?.Ordem){
              return -1
            }
            return 1;
          });
        })
        .catch( error => {
          console.log(error);
        });
    axios.get(`/faculdades/${this.id}/departamentos?idioma=${this.language}`)
        .then(data => {
          this.departamentos = data.data;
        })
        .catch( error => {
          console.log(error);
        });
  },
  updated() {
    if(this.breadcrumb.length > 3){
      this.breadcrumb[3].text = this.$store.state.faculdade?.sigla;
    }
  },
  methods:{
    goToDepartamento(departamento){
      const l = this.language == "pt" ? "" : "en/";
      window.location = `${import.meta.env.VITE_APP_SITE_URL}/${l}departamentos/${departamento.Name}/pessoas`
    }
  }
}
</script>

<style scoped>
.orgaoslist{
  padding-top: 30px;
}

.fundo_papel5 {
  background-color: white;
  padding-bottom: 100px;
}

.departamentos4 {
  padding-top: 20px;
}

.orgaos_breadcrumb {
  display: flex;
  justify-content: center;
  padding-top: 15px;
}

.fundo_cor_faculdade2 {
  background-color: #e9eaea;
  padding-bottom: 130px;
}

.botao_faculdade {
  font-family: 'Montserrat Bold';
  font-size: 14px;
  margin-left: 0;
  letter-spacing: 0.3px;
  padding: 18px 50px;
  margin-bottom: 0 !important;
  width: 100%;
  text-transform: uppercase;
}

.botao_fac {
  text-align: center;
  width: 100%;
  /*margin-top: 60px;*/
}


.departamentoblock{
  margin-bottom: 30px;
}


/*Media query a ser aplicada em "IPAD"*/

@media (min-width : 768px)
and (max-width : 1024px){

  .botao_faculdade {
    font-size: 13px;
    padding-top: 13px;
    padding-bottom: 13px;
  }

  .botao_fac {
    margin-top: 20px;
  }

  .breadcrumbs li {
    font-size: 14px;
  }

  .departamentoblock{
    margin-bottom: 15px;
  }

}

/*Media query a ser aplicada em "IPHONE"*/

@media (max-width: 767px){

  .departamentos4 {
    margin-left: 0!important;
  }

  .departamentoblock{
    margin-bottom: 15px;
  }

  .orgaos_breadcrumb {
    display: none;
  }

  .botao_faculdade {
    font-size: 11px;
    padding-top: 13px;
    padding-bottom: 13px;
  }

  .fundo_papel5 {
    padding-bottom: 50px;
  }

  .fundo_cor_faculdade2 {
    padding-bottom: 50px;
  }
}
</style>